import { Show } from 'solid-js';
import { mode, PaymentMode } from '~/hooks/usePaymentMode';
import { PayTrialPaymentMethodGate } from './PayTrialPaymentMethodGate';
import { PortalTrialPaymentMethodGate } from './PortalTrialPaymentMethodGate';
import type { TrialPaymentMethodModalProps } from './trialPaymentMethodModal.types';

export const TrialPaymentMethodModal = (props: TrialPaymentMethodModalProps) => {
  return (
    <Show when={mode() === PaymentMode.Portal} fallback={<PayTrialPaymentMethodGate {...props} />}>
      <PortalTrialPaymentMethodGate {...props} />
    </Show>
  );
};
